import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import {
  returnValue,
  returnUserContent,
  returnBlockValue,
} from '@/utils/op-types/helperFunctions'

import Linker from '@/components/optypes/headlesss-components/Link'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

const Block = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <div
      className={Classnames('shadow-lg border-2 rounded transition transform', {
        'scale-105 shadow-xl': returnBlockValue(
          'featured',
          'design',
          opBlocks[block],
          design
        ),
      })}
      style={{
        backgroundColor: returnValue('columnbgcolor', opDesign, pageDesign),
        borderColor: returnBlockValue(
          'titlebgcolor',
          'design',
          opBlocks[block],
          design
        ),
      }}
    >
      {/* header */}
      <div
        className=" text-white py-4 px-6"
        style={{
          backgroundColor: returnBlockValue(
            'titlebgcolor',
            'design',
            opBlocks[block],
            design
          ),
          color: returnBlockValue(
            'titletextcolor',
            'design',
            opBlocks[block],
            design
          ),
        }}
      >
        <div className="text-2xl text-center font-bold">
          {returnBlockValue('title', 'content', opBlocks[block], content)}
        </div>
        <div className="text-sm text-center">
          {returnBlockValue('blurb', 'content', opBlocks[block], content)}
        </div>
      </div>

      <div className="p-4 space-y-3">
        {returnBlockValue('links', 'content', opBlocks[block], content).map(
          (data, index) => (
            <Linker key={index} data={data.url} className="">
              <div
                className={Classnames(
                  'transition-all w-full transform hover:scale-105 cursor-pointer hover:shadow-xl rounded shadow mb-1.5',
                  {
                    'p-6':
                      returnValue('linklayout', opDesign, pageDesign) == 'lg',
                    'flex py-3 px-3 items-center overflow-hidden':
                      returnValue('linklayout', opDesign, pageDesign) == 'sm',
                  }
                )}
                style={{
                  backgroundColor: returnValue(
                    'linkbgcolor',
                    opDesign,
                    pageDesign
                  ),
                  color: returnValue('linktextcolor', opDesign, pageDesign),
                }}
              >
                {data.url.meta.img && (
                  <div className="flex-shrink-0">
                    <img
                      src={data.url.meta.img}
                      alt=""
                      className={Classnames('rounded', {
                        'w-full mb-4':
                          returnValue('linklayout', opDesign, pageDesign) ==
                          'lg',
                        'w-24 mr-3.5':
                          returnValue('linklayout', opDesign, pageDesign) ==
                          'sm',
                      })}
                    />
                  </div>
                )}
                <div
                  className={Classnames('flex-grow', {
                    'w-full md:pr-6 ':
                      returnValue('linklayout', opDesign, pageDesign) == 'lg',
                  })}
                >
                  <div
                    className={Classnames({
                      'font-bold text-xl line-clamp-3':
                        returnValue('linklayout', opDesign, pageDesign) == 'lg',
                      'font-bold text-base line-clamp-2':
                        returnValue('linklayout', opDesign, pageDesign) == 'sm',
                    })}
                  >
                    {data.url.meta.title}
                  </div>
                  <div
                    className={Classnames('font-medium opacity-50', {
                      'line-clamp-2 text-sm my-2 ':
                        returnValue('linklayout', opDesign, pageDesign) == 'lg',
                      'line-clamp-1 text-xs mt-0 ':
                        returnValue('linklayout', opDesign, pageDesign) == 'sm',
                    })}
                  >
                    {data.url.meta.desc}
                  </div>
                  <div
                    className={Classnames({
                      hidden:
                        returnValue('linklayout', opDesign, pageDesign) == 'sm',
                      'font-medium line-clamp-1 text-xs mt-1':
                        returnValue('linklayout', opDesign, pageDesign) == 'lg',
                    })}
                    style={{
                      color: returnValue('linkurlcolor', opDesign, pageDesign),
                    }}
                  >
                    {data.url.url}
                  </div>
                </div>
              </div>
            </Linker>
          )
        )}
      </div>
    </div>
  )
}

export default Block
